import UserRoles from "./UserRoles";
import LicenseTypes from "./LicenseTypes";
import LoginPageTypes from "./LoginPageTypes";

class index {
  constructor() {
    this.UserRoles = new UserRoles();
    this.LicenseTypes = new LicenseTypes();
    this.LoginPageTypes = new LoginPageTypes();
  }
}

export default index;



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Enums/index.js